import { currentLocationPos } from '../../../../../interfaces/interfaces';

const currentLocation = (map: google.maps.Map, setCurrentLocation: (x: currentLocationPos | null) => void) => {
  const infoWindow: google.maps.InfoWindow = new google.maps.InfoWindow();
  const handleLocationError = () => {
    // infoWindowObj.setPosition(pos);
    // infoWindowObj.setContent(browserHasGeolocation ? 'Error: The Geolocation service failed.' : "Error: Your browser doesn't support geolocation.");
    // infoWindowObj.open(map);
    setCurrentLocation(null);
    sessionStorage.removeItem('currentPosition');
  };

  const getCurrentPosition = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position: GeolocationPosition) => {
          const pos = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          };
          setCurrentLocation(pos);
          sessionStorage.setItem('currentPosition', JSON.stringify(pos));
          infoWindow.setPosition(pos);
          infoWindow.setContent('Location found.');
          infoWindow.open(map);
          map.setCenter(pos);
        },
        () => {
          handleLocationError();
        }
      );
    } else {
      handleLocationError();
    }
  };

  return {
    getCurrentPosition,
  };
};

export default currentLocation;
